export function ExternalLinkNotice() {
  return <span className="sr-only"> (opens in a new tab)</span>
}
